import {
  Component, OnInit, AfterViewInit, ViewChild, ContentChild, style, state, animate,
  transition, trigger, Directive, Optional
} from '@angular/core';
import {FormControlDirective, FormControlName, FormControl, NgControl} from "@angular/forms";
import {MatFormField, MatInput} from "@angular/material";
import {Observable} from "rxjs";

@Directive({
  selector: 'input',
  host: {
    '(blur)': 'onBlur($event)'
  }
})
export class ValidateOnBlurDirective {
  constructor(@Optional() public formControl: NgControl = null) {
  }

  onBlur($event) {
    if (this.formControl != null) {
      this.formControl.control.updateValueAndValidity();
    }
  }
}

@Directive({
  selector: 'mat-form-field[validationInput]',
  host: {
    '(blur)': 'onBlur($event)'
  }
})
export class ValidationInputComponent implements AfterViewInit {

  @ContentChild(FormControlDirective) formControlDirective: FormControlDirective;
  @ContentChild(FormControlName) formControlNameDirective: FormControlName;

  private formControl: FormControl;

  constructor(private el: MatFormField) {
  }

  ngAfterViewInit(): void {
    if (this.formControlDirective != null) {
      this.formControl = this.formControlDirective.control;
    } else if (this.formControlNameDirective != null) {
      this.formControl = this.formControlNameDirective.control;
    } else {
      throw new Error("no formControl children");
    }

    Observable.merge(this.formControl.statusChanges,
      this.formControl.valueChanges,
      this.formControl.root.statusChanges) // TODO remove this workaround if other solution possible
      .debounceTime(200).subscribe(() => this.buildErrorMessage());

  }

  private buildErrorMessage() {
    let errors = this.formControl.errors;
    if (errors ) {
      // TODO use translation once RC7 is out
      if (this.el != null) {
        this.el.dividerColor = "warn";
        this.el.hintLabel = Object.keys(errors).join(", ");
      }
    } else if (this.el != null && !this.formControl.pristine) {
        this.el.dividerColor = "primary";
        this.el.hintLabel = null;
    }
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/validation-input/validation-input.component.ts